<section class="blog single-blog section"  >
  <div class="container container-xs">
      <div class="row">
          <div class="col-xxl-10 offset-xxl-1 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-xs-12  animated fadeIn">
          </div>

          <div class="col-xxl-10 offset-xxl-1 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-xs-12  burbujalineal animated fadeIn">

            <div class="row" *ngIf="loading">
              <div class="col-12">
                  <div class="alert alert-info text-center">
                      <h4 class="alert-heading">Cargando</h4>
                      <i class="fa fa-sync fa-spin fa-3x"></i>
                      <p class="mb-0">Espera por favor...</p>
                  </div>
              </div>
            </div>


              <h4 class="tit">{{titulo}}</h4>
              <form autocomplete="off" [formGroup]="formu" (ngSubmit)="guardar()">
               <div class="form-group row">
                  <label class="col-sm-12 col-md-12   col-form-label">Asociado a</label>
                  <div class="col">
                    <label>{{enunciado}}</label>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-12 col-md-12  col-form-label">Nombre</label>
                  <div class="col">
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Nombre"
                      formControlName="nombre"
                      maxlength="50"
                    />
                    <small *ngIf="nombreNoValido" class="text-danger">
                      Por favor ingresa el nombre del videotutorial
                    </small>
                  </div>
                </div>

                  <div class="form-group row">
                    <label class="col-sm-12 col-md-12  col-form-label">URL</label>
                    <div class="col">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="URL"
                        formControlName="url"
                        maxlength="200"
                       (focusout) = "setearOrigen($event)"
                      />
                      <small *ngIf="urlNoValida" class="text-danger">
                        Por favor ingresa la URL del video, o verifica que la misma sea una url correcta, e incluya el protocolo de la misma. <br>Ejemplo: https://www.youtube.com/watch?v=dIgtdst_bXk
                      </small>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-12 col-md-12  col-form-label">Origen del video</label>
                    <div class="col">
                      <select class="form-control form-select" formControlName="tipo" (change)="cambiarTipo($event)">
                        <option value="" disabled>Selecciona el origen</option>
                        <option value="Stream">Microsoft Stream</option>
                        <option value="Youtube">Youtube</option>
                      </select>
                      <small *ngIf="tipoNoValido" class="text-danger">
                        Por favor selecciona el origen del video
                      </small>
                      <small *ngIf="origenNoValido" class="text-danger">
                        El origen del video no corresponde con la url
                      </small>
                    </div>
                  </div>



                <div class="form-group row">
                  <label class="col-sm-12 col-md-12  col-form-label">&nbsp;</label>
                  <div class="input-group col">
                    <button type="button" (click)="volver()" class="btn editar mr-3 mt-3 btn-danger">
                      <i class="fas fa-undo-alt"></i> Cancelar
                    </button>&nbsp;
                    <button type="submit" class="btn btn-success guardar mr-3 mt-3">
                      <i class="fa fa-save"></i> Guardar
                    </button>
                    &nbsp;

                  </div>
                </div>
              </form>

          </div>



          <div class="col-md-10 offset-md-1 col-lg-2 offset-lg-0">
              <div class="sidebar">
                  <!-- Search Widget -->
                  <div class="widget search p-0">

                  </div>
                  <div class="widget related-store">
                    <!-- Widget Header -->

                </div>
                  <!-- Category Widget -->
                  <div class="widget category">
                      <!-- Widget Header -->

                  </div>
                  <!-- Store Widget -->
              </div>
          </div>
      </div>
  </div>
</section>


